import { MoneyInput } from '@perpay-web/components/base/MoneyInput/MoneyInput';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikMoneyInput = withFormikInputWrapper(MoneyInput);

/**
 * @type {any}
 */
export default FormikMoneyInput;
